import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinFinder',
  props: {
    value: {
      type: [Number, Boolean],
      default: function _default() {
        return null;
      }
    },
    appendIcon: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    userId: {
      type: String,
      default: function _default() {
        return null;
      }
    },
    parentId: {
      type: Number,
      default: function _default() {
        return null;
      }
    },
    sameTenant: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tenantId: {
      type: Number,
      default: function _default() {
        return null;
      }
    },
    tagFilter: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    objectFilter: {
      type: Function,
      default: null
    },
    required: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    requiredErrorText: {
      type: String,
      default: null,
      required: false
    },
    readonly: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    dense: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    // eslint-disable-next-line vue/require-prop-types
    hideDetails: {
      required: false,
      default: function _default() {
        return false;
      }
    },
    loadFullDtwinData: {
      type: Boolean,
      required: false,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      treeMenu: false,
      treeMenuPosition: {},
      digitalTwin: null,
      isLoading: false,
      rules: [function () {
        return !!_this.digitalTwin || _this.requiredErrorText || _this.$i18n_t('IS.FM.AccessMgmt.accessObjectReq');
      }],
      noRules: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    readonlyName: function readonlyName() {
      if (this.digitalTwin) {
        return "".concat(this.digitalTwin.title, " (").concat(this.$i18n_t('Common.id'), ": ").concat(this.digitalTwin.id, ")");
      }

      return this.label || this.$i18n_t('Common.digitalTwins.searchPlaceholder');
    }
  }),
  watch: {
    value: function value() {
      this.fetch();
    },
    disabled: function disabled(newVal) {
      if (!newVal) {
        this.fetch();
      }
    }
  },
  mounted: function mounted() {
    this.fetch();
  },
  methods: {
    doOpenTree: function doOpenTree(e) {
      e.preventDefault();

      if (!this.disabled) {
        this.treeMenuPosition = {
          x: e.clientX,
          y: e.clientY
        };
        this.treeMenu = true;
      }
    },
    process: function process() {
      this.$emit('input', this.digitalTwin ? parseInt(this.digitalTwin.id) : undefined); // for legacy support, or if the whole object is required

      this.$emit('dtwin-selected', this.digitalTwin);
    },
    digitalTwinSelected: function digitalTwinSelected(e) {
      // NOTE: the tree emits the selection of a twin right after startup
      // this would lead to the tree never really opening, if the already selected twin is emitted again
      // so in that case, ignore the emission as nothing changes
      if (e && this.digitalTwin && e.id === this.digitalTwin.id) {
        return;
      }

      this.digitalTwin = e;
      this.treeMenu = false;
      this.process();
    },
    fetch: function fetch() {
      var _this2 = this;

      if (this.disabled || !this.value) {
        return;
      }

      this.loading = true;
      ApiService.digitalTwinGet(this, this.value, !this.loadFullDtwinData).then(function (dtwin) {
        if (!_this2.tenantId || dtwin.tenantId === _this2.tenantId) {
          _this2.digitalTwin = dtwin;
        } else {
          _this2.digitalTwin = null;
        }

        _this2.process();
      }).catch(function () {
        _this2.loading = false;
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
};